import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { RoleNames, RoutePaths } from '../shared/api/types/enums';
import { RoleGuard } from '../shared/guards/role.guard';

// Shop and Channel
export const shopAndChannelRoutes: Routes = [
  {
    path: RoutePaths.SacChannels,
    loadChildren: () =>
      import('src/app/shop-and-channels/channels/channels.module').then((mod) => mod.ChannelsModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.SacCarriers,
    loadChildren: () => import('src/app/order-management/carriers/carriers.module').then((mod) => mod.CarriersModule),
    data: { role: [RoleNames.logistics, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.SacWarehouses,
    loadChildren: () =>
      import('src/app/order-management/warehouses/warehouses.module').then((mod) => mod.WarehousesModule),
    data: { role: [RoleNames.logistics, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.SacOrderStatuses,
    loadChildren: () =>
      import('src/app/order-management/order-status/order-status.module').then((mod) => mod.OrderStatusModule),
    data: { role: [RoleNames.order, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.SacPaymentMethods,
    loadChildren: () =>
      import('src/app/order-management/paymethods/paymethods.module').then((mod) => mod.PaymethodsModule),
    data: { role: [RoleNames.shop, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.SacTemplates,
    loadChildren: () => import('src/app/admin/templates/templates.module').then((mod) => mod.TemplatesModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.SacEventActions,
    loadChildren: () =>
      import('src/app/e-business/event-actions/event-actions.module').then((mod) => mod.EventActionsModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: RoutePaths.SacBusinessRules,
    loadChildren: () => import('src/app/business-rules/business-rules.module').then((mod) => mod.BusinessRulesModule),
    data: { role: [RoleNames.configuration, RoleNames.backoffice] },
    canActivate: [AuthGuard, RoleGuard]
  }
];
